import React from 'react';
import Button from 'gatsby-theme-pages/src/components/nav/list-nav/button';
import styled from 'styled-components';
import Bars from 'icons/src/Bars';

const StyledButton = ({ className, ...props }) => (
  <Button
    className={className}
    {...props}
  >
    <Bars />
    MENU
  </Button>
);
export default styled(StyledButton)`
  color: white;
  padding: 0;
  font-size: .75rem;
  flex-direction: column;
  align-items: center;
  svg {
    width: 2.25rem;
  }
`;
